<div style="padding:30px">  
    <button class="btn btn-primary" (click)="edit_data.id=-1;init_edit_data()"  data-toggle="modal" data-target=".bd-example-modal-xl">新增LV</button>
    <table style="margin-top: 10px;" class="table table-responsive-sm" *ngIf="data.length>0">
        <thead>
        <tr class="table-primary" style="font-size:18px;">
            <th style="width:8%;overflow: auto;">LV名稱</th>
            <th style="width:5%">強制show</th>
            <th style="width:5%">類型</th>
            <th style="width:5%">開始日</th>
            <th style="width:5%">到期日</th>
            <th style="width:5%">操作</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of data; let i = index" class="{{(item.status==0)?'table-secondary':''}}">
            <td>
               {{item.name}}
            </td>
            <td>
               {{item.can_choose_show==1?'是':'否'}}
            </td>
            <td>
               {{item.tname}}
            </td>
            <td>
                {{item.start_count_date}}      
            </td>
            <td>
                {{item.dead_line_date}}      
            </td>
            <td>
                <button *ngIf="item.status != 0" (click)="edit_data = item;ck_type_list()"  data-toggle="modal" data-target=".bd-example-modal-xl" class="btn btn-primary">編輯</button>
                <button (click)="copy(item)"  data-toggle="modal" data-target=".bd-example-modal-xl" class="btn btn-info">複製</button>
            </td>
        </tr>
        </tbody>
    </table>
    <div *ngIf="data.length==0">無資料</div>
    <app-pagnation (callback)="callback($event)"  [data]="pageobjstr"></app-pagnation>
   


    <div 
    *ngIf="edit_data"
    class="modal fade bd-example-modal-xl" tabindex="-1"
     role="dialog"  data-keyboard="false" data-backdrop="static" 
     aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
      style="max-height: 650px;overflow:auto;"
     >
      <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title" >LV設定</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <!-- Modal body -->
            <div style="padding: 10px;">
                <div class="user_edit_block" *ngIf="now=='1'">
                    <label class="col-sm-2 col-form-label">Rank名稱</label>
                    <input  [disabled]="edit_data.has!=0 ? true : null"  type="text" [(ngModel)]="edit_data.name" placeholder="Rank描述" class="form-control fix_input" >
                </div>

                <div class="user_edit_block">
                    <label class="col-sm-2 col-form-label">性別</label>
                    <button *ngIf="edit_data.has==0" [ngClass]="edit_data.gender==2?'btn-danger':'btn-secondary'"  (click)="edit_data.gender=2;ck_type_list()" class="btn" >女生</button>
                    <button *ngIf="edit_data.has==0" [ngClass]="edit_data.gender==1?'btn-danger':'btn-secondary'"  (click)="edit_data.gender=1;ck_type_list()" class="btn" >男生</button>
                    <span *ngIf="edit_data.has!=0">{{edit_data.gender==1?'男生':'女生'}}</span>
                </div>
                <div class="user_edit_block">
                    <label class="col-sm-2 col-form-label">可裝備</label>
                    <button *ngIf="edit_data.has==0" [ngClass]="edit_data.can_choose_show==1?'btn-danger':'btn-secondary'"  (click)="edit_data.can_choose_show=1;ck_type_list()" class="btn" >是</button>
                    <button *ngIf="edit_data.has==0" [ngClass]="edit_data.can_choose_show==0?'btn-danger':'btn-secondary'"  (click)="edit_data.can_choose_show=0;ck_type_list()" class="btn" >否</button>
                    <span *ngIf="edit_data.has!=0">{{edit_data.can_choose_show==1?'是':'否'}}</span>
                </div>
                <div class="user_edit_block" *ngIf="tool_list.type_list.length>0">
                    <label class="col-sm-2 col-form-label">類型</label>
                    <select class="form-control"
                    style="width: 160px;display: inline-block;"
                    [(ngModel)]="edit_data.tid"
                    [disabled]="edit_data.has!=0 ? true : null" 
                    >
                        <option *ngFor="let item of tool_list.type_list_option_list" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <div *ngIf="edit_data.tid==1" style="margin-top: 10px;" class="tips offset-sm-2">等級會依參照活動計算,時間僅為新等級得有效區間</div>
                    <div *ngIf="edit_data.tid!=1" style="margin-top: 10px;" class="tips offset-sm-2">時間區間為新等級的有效區間且會持續計算等級</div>
                </div>
               
                <div class="user_edit_block" *ngIf="tool_list.active_list.length>0 && edit_data.tid*1 == 1">
                    <label class="col-sm-2 col-form-label">參照活動</label>
                    <select class="form-control"
                    style="width: 220px;display: inline-block;"
                    [(ngModel)]="edit_data.past_aid"
                    [disabled]="edit_data.has!=0 ? true : null" 
                    >
                    <option *ngFor="let item of tool_list.active_list" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                </div>
                <div class="user_edit_block" *ngIf="tool_list.active_list.length>0 && edit_data.tid*1 == 1">
                    <label class="col-sm-2 col-form-label">本次活動</label>
                    <select class="form-control"
                    style="width: 220px;display: inline-block;"
                    [(ngModel)]="edit_data.aid"
                    [disabled]="edit_data.has!=0 ? true : null" 
                    >
                    <option *ngFor="let item of tool_list.active_list" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                </div>

                <div class="user_edit_block" *ngIf="edit_data.tid*1 != 1">
                    <label class="col-sm-2 col-form-label">每月重算</label>
                    <button  [ngClass]="edit_data.recount_month==1?'btn-danger':'btn-secondary'"  (click)="edit_data.recount_month=1" class="btn" >是</button>
                    <button  [ngClass]="edit_data.recount_month==0?'btn-danger':'btn-secondary'"  (click)="edit_data.recount_month=0" class="btn" >否</button>
                  
                </div>
                <div class="user_edit_block" *ngIf="edit_data.recount_month!=1">
                    <label class="col-sm-2 col-form-label">開始日</label>
                    <input  [disabled]="edit_data.has!=0 ? true : null"  type="date" [(ngModel)]="edit_data.start_count_date" placeholder="有效期限" class="form-control fix_input" >
                </div>
                <div class="user_edit_block" *ngIf="edit_data.recount_month!=1">
                    <label class="col-sm-2 col-form-label">結束日</label>
                    <input  [disabled]="edit_data.has!=0 ? true : null"  type="date" [(ngModel)]="edit_data.dead_line_date" placeholder="有效期限" class="form-control fix_input" >
                    <button *ngIf="edit_data.has==0" class="btn btn-primary" (click)="edit_data.dead_line_date='2050-01-01'">永久</button>
                </div>

                
                <div class="user_edit_block">
                    <div class="offset-sm-1">
                        <button *ngIf="edit_data.has==0" (click)="add_new();recaculate()" class="btn btn-primary">新增等級</button>
                        <button *ngIf="edit_data.has==0" (click)="rename()" class="btn btn-success">預設名稱</button>
                        <div *ngFor="let item of edit_data.detail; let i = index">
                            <div>
                                <label class="col-sm-1 col-form-label">等級{{i+1}}</label>
                                {{item.diamond_start}} ~
                                <input  [disabled]="edit_data.has!=0 ? true : null"  *ngIf="edit_data.detail.length*1-1 > i" type="number" [(ngModel)]="item.diamond_end" (change)="recaculate()" placeholder="門檻鑽石數" class="form-control fix_input" >
                                <span *ngIf="edit_data.detail.length*1-1 == i">無限</span>
                                <div class="tips offset-sm-1">單位:{{edit_data.tid==1?'分數':'元'}}</div>
                            </div>                   
                            <div>
                                <label class="col-sm-1 col-form-label">等級名稱</label>
                                <input type="text" [(ngModel)]="item.name" placeholder="等級名稱" class="form-control fix_input" >
                            </div>
                            <div>
                                <label class="col-sm-1 col-form-label">升級獎勵</label>
                                <input  [disabled]="edit_data.has!=0 ? true : null"  type="number" [(ngModel)]="item.once_reward" placeholder="升級獎勵" class="form-control fix_input" >
                            </div>
                             <div>
                                <label class="col-sm-1 col-form-label">是否參照</label>
                                <button *ngIf="edit_data.has==0" [ngClass]="item.real_info=='1'?'btn-danger':'btn-secondary'"  (click)="item.real_info='1'" class="btn" >是</button>
                                <button *ngIf="edit_data.has==0" [ngClass]="item.real_info=='0'?'btn-danger':'btn-secondary'"  (click)="item.real_info='0'" class="btn" >否</button>
                                <span *ngIf="edit_data.has!=0">{{item.real_info=='1'?'是':'否'}}</span>                             
                            </div>
                            <button *ngIf="i!=0 && edit_data.has==0" (click)="edit_data.detail.splice(i,1);recaculate()" style="width:45%;margin:20px" class="btn btn-danger">刪除</button>
                            <button *ngIf="i!=0 && edit_data.has!=0"  style="width:45%;margin:20px" class="btn btn-secondary">刪除</button>
                            <hr>
                        </div>
                    </div>
                   
                    
                </div>
            </div>
          
            <!-- Modal footer -->
            <div class="modal-footer" >
                <button type="button"   (click)="save()"    class="btn btn-primary" data-dismiss="modal">確認</button>
                <button type="button"   (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>
          </div>
      </div>
    </div>
</div>